import Add from "./add";
import Delete from "./delete";
import Edit from "./edit";
import ManageRoles from "./manage-roles";

export const User = { Add, Delete, Edit, ManageRoles };
